<template>
  <div class="about-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <div class="min-height-300 bg-primary position-absolute w-100"></div>
    <page-hero
      title="Nolido"
      subtitle="À propos de nous"
      description="Découvrez notre vision et notre engagement pour la transformation numérique."
      :showBreadcrumb="true"
    />
    <main class="main-content position-relative border-radius-lg">
      <div class="container-fluid py-4">
        <div class="row">
          <div class="col-12 mb-4">
            <div class="card">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="d-flex flex-column h-100">
                      <h5 class="font-weight-bolder">Notre histoire</h5>
                      <p class="mb-5">Fondée avec la vision d'accompagner les entreprises dans leur transformation numérique, Nolido s'est établie comme un acteur majeur de l'innovation technologique. Notre engagement est de fournir des solutions sur mesure qui répondent aux défis modernes des entreprises.</p>
                      <div class="features">
                        <h6 class="font-weight-bolder mb-3">Nos valeurs fondamentales :</h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Innovation continue
                          </li>
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Excellence technique
                          </li>
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Engagement client
                          </li>
                          <li class="mb-2">
                            <i class="fas fa-check text-success me-2"></i>
                            Transparence
                          </li>
                          <li>
                            <i class="fas fa-check text-success me-2"></i>
                            Responsabilité sociale
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 mt-4 mt-lg-0">
                    <img src="@/assets/img/49375.jpg" alt="L'équipe Nolido" class="w-100 border-radius-lg shadow-lg">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12 mb-4">
            <div class="card">
              <div class="card-body p-3">
                <h5 class="font-weight-bolder mb-4">Nos solutions</h5>
                <div class="row">
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex">
                      <div>
                        <div class="icon icon-shape bg-gradient-primary shadow text-center">
                          <i class="ni ni-building text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="ms-3">
                        <h6>N'Business</h6>
                        <p>Solution complète de gestion d'entreprise</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex">
                      <div>
                        <div class="icon icon-shape bg-gradient-primary shadow text-center">
                          <i class="ni ni-app text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="ms-3">
                        <h6>N'Lite</h6>
                        <p>Gestion simplifiée pour TPE/PME</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex">
                      <div>
                        <div class="icon icon-shape bg-gradient-primary shadow text-center">
                          <i class="ni ni-compass-04 text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="ms-3">
                        <h6>N'Consulting</h6>
                        <p>Expertise en transformation digitale</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-6">
                    <div class="d-flex">
                      <div>
                        <div class="icon icon-shape bg-gradient-primary shadow text-center">
                          <i class="ni ni-support-16 text-lg opacity-10" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="ms-3">
                        <h6>Support dédié</h6>
                        <p>Accompagnement personnalisé</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    
    <!-- Testimonials Section -->
    <testimonials-section />
    
    <!-- FAQ Section -->
    <faq-section />

    <!-- Final CTA Section -->
    <section class="final-cta-section">
      <div class="container h-100 position-relative">
        
        <div class="row justify-content-center text-center pt-5 position-relative z-index-10">
          <div class="col-lg-8">
            <h2 class="text-white fw-bold mb-3" style="font-size: 1.8rem;">
              Vous avez choisi Nolido, et<br>
              <span class="position-relative d-inline-block">
                vous avez raison...
                <svg class="underline-svg" viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12 C 50 6, 150 6, 195 10" stroke="#F5A847" stroke-width="2.5" stroke-linecap="round"/>
                </svg>
              </span>
            </h2>
            <button class="btn btn-download-cta rounded-pill mt-2">
              Télécharger maintenant
            </button>
          </div>
        </div>

        <!-- Absolute Positioned Images (Desktop) -->
        <div class="phone-wrapper d-none d-lg-block">
           <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="phone-app-img">
        </div>

        <div class="collage-wrapper d-none d-lg-block">
           <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="collage-img">
        </div>

        <!-- Stacked Layout for Mobile/Tablet -->
         <div class="row align-items-center mt-5 d-flex d-lg-none">
          <div class="col-12 text-center mb-4">
             <div class="collage-wrapper">
                <img :src="require('@/assets/img/last_section.png')" alt="Communaute Nolido" class="img-fluid collage-img">
             </div>
          </div>
          <div class="col-12 text-center p-0">
            <div class="phone-wrapper">
              <img :src="require('@/assets/img/last_section_phone.png')" alt="Nolido App" class="img-fluid phone-app-img">
            </div>
          </div>
        </div>
      </div>
    </section>
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import PageHero from '@/components/PageHero.vue';
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';

export default {
  name: 'AboutNolido',
  components: {
    Navbar,
    AppFooter,
    PageHero,
    TestimonialsSection,
    FaqSection
  }
}
</script>

<style scoped>
/* Final CTA Styles */
.final-cta-section {
  background-color: #2F2113;
  position: relative;
  overflow: hidden;
  height: 700px;
  padding-top: 2rem;
  background-image: url('~@/assets/img/bande_gauche.png');
  background-position: left 50px;
  background-repeat: no-repeat;
  background-size: 350px auto;
  margin-top: 0; 
}

.underline-svg {
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 250px; 
  height: auto;
}

.btn-download-cta {
  background-color: #eebb89;
  color: #2F2113;
  font-weight: 700;
  border: none;
  font-size: 0.95rem;
  padding: 0.6rem 2rem;
  box-shadow: 0 4px 0 #c29568;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  z-index: 10;
}

.btn-download-cta:hover {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #c29568;
}

.phone-wrapper {
  position: absolute;
  bottom: -40px;
  left: 5%;
  z-index: 5;
  width: 280px; 
}

.phone-app-img {
  width: 100%;
  height: auto;
}

.collage-wrapper {
  position: absolute;
  bottom: 60px;
  right: 2%;
  z-index: 5;
  width: 360px;
}

.collage-img {
  width: 100%;
  height: auto;
  transform: rotate(3deg);
  border-radius: 12px;
}

@media (max-width: 991px) {
  .final-cta-section {
    height: auto;
    min-height: 500px;
    padding-bottom: 0;
    background-image: none;
    padding-top: 3rem;
  }
  
  .phone-wrapper {
    position: relative;
    bottom: 0;
    left: 0;
    margin-top: 2rem;
    margin-bottom: -10px;
    display: inline-block;
  }
  
  .collage-wrapper {
    position: relative;
    bottom: 0;
    right: 0;
    display: inline-block;
  }
  
  .collage-img {
    transform: rotate(0);
  }
}
</style>